'use strict';

import minicart from '../minicart';
import account from './account';
import bonusProductsView from '../bonus-products-view';
import quickview from '../quickview';
import images from './product/image';
import variant from './product/variant';
import giftShipping from './checkout/shipping';
import recommendations from './product/recommendations';
import cartStoreInventory from '../storeinventory/cart';
import modalExport from '../modal';
const modal = modalExport.global;
import samples from '../samples';
import login from './checkout/login';
import progress from '../progress';
import util from '../util';
import analytics from '../analytics';
import validator from '../validator';
import tooltip from './../tooltip';
import page from '../page';
import customVideoPlayer from './product/customVideoPlayer';
import reinsurancePanel from './reinsurancePanel';
import paypalExpress from '../adyen/paypalExpress';
import ajax from '../ajax';
import customDropdown from '../custom-dropdown';
import googlePayExpress from '../adyen/googlePayExpress';

/**
 * @private
 * @function
 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
 */

function reinsuranceCart() {
	$(document).on('click', '.reinsurance-wrapper-cart', function (e) {
        e.stopImmediatePropagation();
        if($(this).parent().hasClass("open-reinsurance-panel")) {
            $(this).prop("disabled", false);
			var contentAssetId = $(this).parent().attr("data-content-id");
			reinsurancePanel.openReinsurancePanel(contentAssetId);
        } else {
            if($(this).hasClass('desktop-only')) {
                $(this).toggleClass('show-description')
                $(this).siblings().toggleClass('hidden');
                $(this).parents('.content-asset').toggleClass('flex-ease');
                $('.reinsurance-wrapper-cart').not(this).removeClass('show-description');
            } else {
                $(this).toggleClass('show-description')
                $(this).siblings().toggleClass('hidden');
                $(this).parents('.content-asset').toggleClass('flex-ease');
                $(this).parents('.reinsurance-checkout-mobile .content-asset').siblings().toggleClass('hide');
                $('.reinsurance-wrapper-cart').not(this).removeClass('show-description');
            } 
        }
	});
	
	$(document).ready(function() { 
        $('.reinsurance-wrapper-cart.mobile-only').parents('.content-asset').addClass('flex-ease');
        $('.reinsurance-wrapper-cart').each(function() {
            if($(this).parent().hasClass("open-reinsurance-panel")) {
                setTimeout(function(){
                    var element = $('.reinsurance-element.open-reinsurance-panel');
                    element.prop("disabled", false);
                }, 500);
            } else {
                if ($(this).find('.reinsuranceDesc').length === 0) {
                    $(this).addClass('remove-plus-icon');
                    $(this).prop("disabled", true);
                }
            }
        });
    });
    
	$(document).on('click', '.reinsurance-checkout-mobile .mobile-only', function (e) {
        e.stopImmediatePropagation();
		if(!$(this).parent().hasClass("open-reinsurance-panel")) {
			if ($(this).find('.reinsuranceDesc').length === 0){
				$(this).on('click', function(event) {
					event.preventDefault();
				});
			} else {
				$('.reinsurance-checkout-mobile .mobile-only').not(this).toggleClass('hidden');
			}
		}
	});
}

function initializeEvents() {
    setTimeout(() => {
    reinsuranceCart();
    }, 1000);

    $('#cart-table').on('click', '.item-edit-details a', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
    	 var viewport_width = $(window).width();
    	    if(viewport_width >= 768){    	
		        e.preventDefault();
		        quickview.show({
		            url: e.target.href,
		            source: 'cart',
		            callback: function() {
                        $('.checkout-reinsurance-inner-wrapper').find('.pdp-main.pdp-quickview').remove();
                        setTimeout(() => {
                            variant();
                        }, 1000);
		                
		                renderThumbnails();
						customVideoPlayer();
		            }
		        });
    	    }
    })
    .on('click', '.bonus-item-actions a, .item-details .bonusproducts a', function (e) {
        e.preventDefault();
        bonusProductsView.show(this.href);
    });

    // override enter key for coupon code entry
    $('input[name$="_couponCode"]').on('keydown', function (e) {
        if (e.which === 13 && $(this).val().length === 0) { return false; }
    });

	//Paypal Error Pop-up OK event
	$(document).on('click', '#paypal-error-ok', function () {
		$('.error-form-wrapper').fadeOut(300);
	});
	$('body').click(function(e) {
		if (!$(e.target).closest('.error-form').length){
			$('.error-form-wrapper').fadeOut(300);
		}
	});

    // product level bonus modal
    $('.cart-column').on('click', '.bonus-item-promo a.select-bonus', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        var urlToRender = $(this).attr('href');
        if (urlToRender) {
            modal.addCustomClass('bonus-item-modal bonus-item-modal-redesign');
            modal.setCallback(function () {
                if($('.reveal.bonus-item-modal-redesign').find('.product-tile-wrapper').length <=  6) {
                    $('.reveal#modal-cntr').addClass('modal-cntr-noscroll');
                    if($(window).width() < 768) {
                        if($('.reveal.bonus-item-modal-redesign').find('.product-tile-wrapper').length < 4) {
                            $('.reveal .product-listing').addClass('product-listing-noscroll');
                        } else {
                            $('.reveal .product-listing').scrollBox();
                            setTimeout(() => {
                                $('.reveal .product-listing').trigger('resize.scrollBox');
                            },  500);
                        }
                    } else {
                        $('.reveal .product-listing').addClass('product-listing-noscroll');
                    }
    
                    if($('.reveal.bonus-item-modal-redesign').find('.product-tile-wrapper').length == 1) {
                        $('.reveal#modal-cntr').addClass('modal-cntr-onesample');
                    } else if($('.reveal.bonus-item-modal-redesign').find('.product-tile-wrapper').length == 2) {
                        $('.reveal#modal-cntr').addClass('modal-cntr-two-sample');
                    } else if($('.reveal.bonus-item-modal-redesign').find('.product-tile-wrapper').length == 3) {
                        $('.reveal#modal-cntr').addClass('modal-cntr-three-sample');
                    } else if($('.reveal.bonus-item-modal-redesign').find('.product-tile-wrapper').length == 4) {
                        $('.reveal#modal-cntr').addClass('modal-cntr-four-sample');
                    } else if($('.reveal.bonus-item-modal-redesign').find('.product-tile-wrapper').length > 4) {
                        $('.reveal#modal-cntr').addClass('modal-cntr-five-sample');
                    }
                } else {
                    $('.reveal .product-listing').scrollBox();
                    setTimeout(() => {
                        $('.reveal .product-listing').trigger('resize.scrollBox');
                    }, 500);
                    $('.reveal#modal-cntr').addClass('modal-cntr-five-sample');
                }
                setTimeout(() => {
                    if($('.reveal .sample-popup-header').height() > 20) {
                        $('.reveal .product-listing').addClass('sample-popup-header__two-lines')
                    }
                }, 500);
            }); 
            $('.bonus-item-modal').parent('.reveal-overlay').addClass('bonus-overlay');
            modal.renderByUrl(urlToRender);
        }
    });

    $(document).on('click', '.sample-container-original, .editsample', function(e){
        e.stopImmediatePropagation();
        samples.showSelectionInCart();
    });

    $(document).on('click', '.paypal-container a', function(e) {
        e.preventDefault();

        var cartCheckoutForm = $('.cart-action-checkout');
        if (cartCheckoutForm.length > 0) {
            cartCheckoutForm.attr('action', Urls.cartPaypalCheckout);
            cartCheckoutForm.submit();
        }
    });

    if(typeof freeShipping!=='undefined') {
        freeShipingLoader();
    }
    
    // executes the script after DOM loading completed
    $(window).on('load', function() {
        // to set scroll position on invalid field
        if (($('.error').length > 0)) {
            $('html, body').animate({
                scrollTop: $("body").find(".error").offset().top - $("#minimized-header-container").outerHeight(true) - 100
            }, 500);
        }
	 });
    
    //apple pay error display
    $(document).on('applePayDisplayErr', function (event, json, string) {
  	  // parameter is stocked in json.data here.
  	 postAppleErr(json.dataErr);
  	});
    
    //nationality
    $(document).on('applePayDisplayNationality', function (event, json, string) {
  	  // parameter is stocked in json.data here.
    	getApplePayDisplayNationality('applepay');
  	});
    
  //consent pop-up
    $(document).on('applePayDisplayConsent', function (event, json, string) {
  	  // parameter is stocked in json.data here.
    	getApplePayConsentModal();
  	});
}

function freeShipingLoader() {    
    $('#free-shipping-indicator').radialIndicator({
        barBgColor: '#d9d9d9',
        barColor: '#353839',
        barWidth: 2,
        currencySymbol: null,
        displayNumber: true,
        format: "##.##",
        fontSize: 15,
        fontFamily: "HelveticaNeueW01-45Ligh",
        fontWeight: "normal",
        initValue: freeShipping.remainingAmount,
        maxValue: freeShipping.threshold,
        radius: 35,
        roundCorner : false,
        reverse: true,
        showCurrency: false,
        displayValue: freeShipping.displayValue
    });
}

function renderThumbnails(){
    if($('#thumbnails').length > 0){
        $('#thumbnails').empty();   // clear the list
        images();                   // populate the thumbnails
    }
};

function isGift () {
    var isGift = (sessionStorage.getItem('isGift') === 'true');
    
    if($(".gift-container .gift-wrap-product-price").length > 0){
    	isGift = ($(".gift-container .gift-wrap-product-price input").val() == 'true') ? true : false;    	
    	if (!isGift) {
            $('.gift-container .input-textarea').val('');
            $('#checkout-form .gift-message').val('');

            sessionStorage.removeItem('isGift');
            sessionStorage.removeItem('giftMessage');
        } else {
            $('.gift-container .input-textarea').keyup();
            sessionStorage.setItem('isGift', isGift);
        }
    }
    
    var isGiftName = [
        $('#cart-items-form').attr('name'),
        'isGift'
    ].join('_');

    $('#checkout-form .is-gift').val(isGift);
    $('#checkout-form .is-gift').attr('name', isGiftName);
    $('.gift-container .input-checkbox').attr('checked', isGift);
    $('.gift-container .input-checkbox').change(function () {
    	progress.show($('.gift-container'));
        isGift = $(this).is(':checked');
        
        var post_url = Urls.onCartGiftUpdate; //get form action url
        
        var form_data = $(this).closest('form').serialize(); //Encode form elements for submission
        $.ajax({
        	url : post_url,
        	type : 'POST',
        	data : form_data
        }).then(function(response){
        	var newOrderSummary = $(response).find('.cart-footer').html();
            $(".cart-footer").html(newOrderSummary);
            progress.hide();
        });
        
        if($(".gift-container .gift-wrap-product-price").length == 0){        	
	        if (!isGift) {
	            $('.gift-container .input-textarea').val('');
	            $('#checkout-form .gift-message').val('');
	
	            sessionStorage.removeItem('isGift');
	            sessionStorage.removeItem('giftMessage');
	        } else {
	            $('.gift-container .input-textarea').keyup();
	            sessionStorage.setItem('isGift', isGift);
	        }
        }

        $('#checkout-form .is-gift').val(isGift);
    });
}

function giftMessage () {
    var giftMessage = sessionStorage.getItem('giftMessage') ? sessionStorage.getItem('giftMessage') : '';
    var giftMessageName = [
        $('#cart-items-form').attr('name'),
        'giftMessage'
    ].join('_');

    $('#checkout-form .gift-message').val(giftMessage);
    $('#checkout-form .gift-message').attr('name', giftMessageName);
    $('.gift-container .input-textarea').val(giftMessage);
    $('.gift-container .input-textarea').on('keyup', function () {
        giftMessage = $(this).val().trim();

        if (giftMessage === '' || util.validateGiftBoxMessage(giftMessage)) {
            $('#checkout-form .gift-message').val(giftMessage);
            $('.gift-message-textarea .form-caption').removeClass('error-message');
            $('.gift-message-textarea .form-caption').empty();
            $('#checkout-form button').prop('disabled', false);

            sessionStorage.setItem('giftMessage', giftMessage);
        } else {
            $('.gift-message-textarea .form-caption').addClass('error-message');
            $('.gift-message-textarea .form-caption').text('Invalid message');
            $('#checkout-form button').prop('disabled', true);
        }
    });
}

function cartCount () {
    if ($('.cart-empty').length) {
        sessionStorage.removeItem('isGift');
        sessionStorage.removeItem('giftMessage');
    }
}

function checkoutReinsurancePopup() {
	$('a.cart-reinsuance-modal').on('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var $this = $(this);
        analytics.reinsuranceElements($this.attr('id'));		
        
        $.ajax({
			url: util.appendParamToURL($this.attr('href'), 'format', 'ajax'),
            method: 'GET'
        })
        .done(function (response) { 
            if(response) {
                modal.addCustomClass('checkout-reinsurance-inner-wrapper');
                modal.renderContent(response);
            }
        });
	});
}

/**
 * Render terms and conditions overlay for paypal express.
 */
function cartPayPalExpressPopup() {
    $('.paypal-button .paypal-cta-text, .paypal-button img.logo').on('click',function(e) {
        e.preventDefault();
    })


	$("#wrapper").on('click keydown', '.button-cart-checkout.paypal-button, .button-cart-checkout.googlepay-button, .applepay-consent-button', function(e) {
        if (e.type === "keydown") {
            if (e.key === " " || e.key === "Spacebar" || e.key === "Enter") {
                e.preventDefault(); // Prevent page scroll for Space
                $(this).trigger("click");
            }

            // Don't interfere with Tab or any other key
            return;
        }
        e.stopImmediatePropagation();

        $(this).hasClass('googlepay-button') && $('body').attr('data-paymentMethod' ,'googlepay_Express');
		$(this).hasClass('paypal-button') && $('body').attr('data-paymentMethod' ,'paypalpay_Express');

		if(Constants.CURRENT_MARKETID == 'it' || Constants.CURRENT_MARKETID == 'es') {
			getApplePayDisplayNationality('paypalECS');
             // calling the same modal which we're using for apple pay.
		}else {
			getPayPalExpressConsentModal();
		}
        $('.reveal-overlay:empty').remove();
	});
	
	$('.paypal-express-termsandconditions-popup').off().on('click', '.cart-paypalexpress-popup .applepaySubmit, #paypal-container, #googlepay-container, .applepay-consent-button', function(e) {
		e.preventDefault();
        e.stopImmediatePropagation();
		var href = $(this).attr('href'),
            $termsCheckbox = $('.paypal-express-termsandconditions-popup input[id$="_userconsent_termsandconditions"]'),
            $termsErrorMsg = $('.paypal-express-termsandconditions-popup .paypal-express-popup-termsandconditions-error');
		
        if($termsCheckbox.is(':checked')) {
            $termsErrorMsg.hide();
            $termsCheckbox.removeClass('error');
            $(".button-cart-checkout.paypal-button").removeClass('disabled');
			if($(this).hasClass("applepaySubmit")){//applepay ajax call
				$.ajax({
					method: 'POST',
					url: href,
					data: {},
					success: function success(data) {
					if (data.error) {
                        $('.button-cart-checkout.paypal-button').attr("disabled",true);
						console.error(data.error);
                        const parser = new URL(window.location);
                        parser.searchParams.set('appleAuthResult', 'true');
                        window.location = parser.href;
					} else {                        
						window.location.href = data.continueUrl;
					}
					},
					error: function error(err) {
                        console.error(err);
                        $('.button-cart-checkout.paypal-button').attr("disabled",true);
                        const parser = new URL(window.location);
                        parser.searchParams.set('appleAuthResult', 'true');
                        window.location = parser.href;
                    }
				});
			}else{
                analytics.paypalExpressSubmitEvent();
			}
        } else {
            $termsErrorMsg.show();
            $termsCheckbox.addClass('error');
            $("#googlepay-container, #paypal-container").addClass('disabled');
        }
	});
    $('.paypal-express-termsandconditions-popup').on('change', 'input[id$="_userconsent_termsandconditions"]', function(){
        var $termsErrorMsg = $('.paypal-express-termsandconditions-popup .paypal-express-popup-termsandconditions-error');
        if($(this).is(':checked')) {
            $termsErrorMsg.hide();
            $(this).removeClass('error');
            $("#googlepay-container, #paypal-container").removeClass('inactive disabled');
        }  else {
            $termsErrorMsg.show();
            $(this).addClass('error');
            $("#googlepay-container, #paypal-container").addClass('inactive').removeClass('disabled');
        }
    });

    // Checkbox toggle to show contnet
	$('.paypal-express-termsandconditions-popup').on('click', '.checkout-newsletter-optin input[type="checkbox"]', function () {
		if($(this).is(":checked")) {
            $(".cart-paypal-exp-terms .newsletter-optin-label .secondary-text").addClass("is-active");
        } else {
            $(".cart-paypal-exp-terms .newsletter-optin-label .secondary-text").removeClass("is-active");
        }
	});
    // Show more content
	$('.paypal-express-termsandconditions-popup').on('click', '.see-more-consent', function () {
		var parentContainer = $(this).parents('.checkout-newsletter-optin');
		$(this).removeClass('is-active');
		$(parentContainer).find('.secondary-text').addClass('is-active');
		$(parentContainer).find('.see-less-consent').addClass('is-active');
	});
	// Show less content
	$('.paypal-express-termsandconditions-popup').on('click', '.see-less-consent', function () {
		var parentContainer = $(this).parents('.checkout-newsletter-optin');
		$(this).removeClass('is-active');
		$(parentContainer).find('.secondary-text').removeClass('is-active');
		$(parentContainer).find('.see-more-consent').addClass('is-active');
	});
    // close Modal
    $('.paypal-express-termsandconditions-popup').on('click', '.close-button', function (){
        closeExpressConsentModal();
    });
}

function closeExpressConsentModal() { //close modal
    $('html').removeClass('is-reveal-open');
    $('#fastcheckout-payment-modal').addClass('hide');
    if ($('body').attr('data-paymentMethod') === 'googlepay_Express') {
        window.location.href = window.returnUrl + '?googleAuthResult=false';
    }
    if ($('body').attr('data-paymentMethod') === 'paypalpay_Express') {
        window.location.href = window.returnUrl + '?paypalAuthResult=false';
    }
}


//Apple Pay Errormsg display
function postAppleErr(errData){	
	$.ajax({
		type: 'POST',
		url: Urls.applePayErrorDisplay,
		data: {data: errData},
		success: function (response) {
			var popupdata = $('.error-popup-modal');
			var popup = new Foundation.Reveal(popupdata);
			$('.error-popup-modal').html(response);
			popup.open();
			
		},
		error: function () {
			alert('something went wrong');
		}
	});	
}

$('body').on('click', '#save-for-later', function (e) {
    // Prevent the default action (no redirection)
    e.preventDefault();
    const wishListLink = $(this).data('href');
    localStorage.setItem('wishListLink', wishListLink);
    // Trigger the click on the target element
    $('.sign-in-wrapper .myaccount').trigger('click');
})


//Apple Pay Display Nationality pop up
function getApplePayDisplayNationality(paymentMethod){
	$.ajax({
		type: 'GET',
		url: Urls.applePayGetNationality,
		data: {},
		success: function (response) {
			var popupdata = $('.apple-pay-nationality-popup');
			var popup = new Foundation.Reveal(popupdata);
			$('.apple-pay-nationality-popup').html(response);
			popup.open();	
			validator.changeFieldValidation();
			if($(".nationalidnumber").val()){
				$(".nationalidnumber").closest('.material-input').addClass("focus-in");
				$("<i class='icon_checkmark'></i>").insertBefore('.nationalidnumber');
			}
            $('.reveal-overlay:empty').remove();
		},
		error: function () {
			alert('something went wrong');
		}
	}).always(function (data) {
		validator.initForm('.apple-pay-modal-content form[id="dwfrm_singleshipping_shippingAddress"]');
		
		 $(document).on('click', '#dwfrm_singleshipping_shippingAddress_save', function(e) {
			e.preventDefault();
			submitNationalityData(paymentMethod);
		});
	});
}

/**
 * submit applepay shipping data
 */
function submitNationalityData(paymentMethod) {
	var $nationalityForm = $('.apple-pay-modal-content #dwfrm_singleshipping_shippingAddress');
	$.ajax({
		type: 'POST',
		url: $nationalityForm.attr('action'),
		data: $nationalityForm.serialize() + '&dwfrm_singleshipping_shippingAddress_save=dwfrm_singleshipping_shippingAddress_save',
		success: function (response) {
			//get consent pop-up
			if(paymentMethod && paymentMethod == 'paypalECS') {
				$('.reveal-overlay').trigger('click');
				getPayPalExpressConsentModal();
			}else {
		       getApplePayConsentModal();	
			}   
		},
		error: function () {
			alert('something went wrong');
		}
	});
}

//trigger PayPal Express consent pop-up
function getPayPalExpressConsentModal() {
    const payMethod = $('body').attr('data-paymentMethod');
	const expressModal = $('.paypal-express-termsandconditions-popup');
    expressModal.after('<div class="express-close-button"></div>');
    $('#fastcheckout-payment-modal').removeClass('hide');
    $('html').addClass('is-reveal-open');
    $(expressModal).find('form').trigger("reset");

	if (payMethod === 'googlepay_Express') {
        analytics.googlePayDataLayerPush();
        if (SitePreferences.ENABLE_GOOGLEPAY_EXPRESS_CHECKOUT) {
            googlePayExpress.mountGooglePayComponent();
        }
		expressModal.find('.paypal-expres-title, #paypal-container, .paypal-active, .consent-error-paypal').addClass('inactive hide');
        expressModal.find('#googlepay-container').addClass('inactive');
        expressModal.find('.googlepay-express-title, #googlepay-container, .googlepay-active, .consent-error-googlepay').removeClass('hide disabled');
	} 
    if (payMethod === 'paypalpay_Express') {
        analytics.payPalDataLayerPush();
         analytics.payPalCartDataLayerPush();
        paypalExpress.mountPaypalComponent();
        expressModal.find('.paypal-expres-title, #paypal-container, .paypal-active, .consent-error-paypal').removeClass('hide disabled');
        expressModal.find('#paypal-container').addClass('inactive');
		expressModal.find('.googlepay-express-title, #googlepay-container, .googlepay-active, .consent-error-googlepay').addClass('inactive hide');
	}

    $('.express-close-button').on('click', function (){
        closeExpressConsentModal();
    });

    clearConsentModalError();
}

//trigger applepay consent modal pop up
function getApplePayConsentModal(){
	$.ajax({
		type: 'GET',
		url: Urls.cartApplePayConsentContent,
		data: {},
		success: function (response) {//reusing papypal express only classes for common validation.
			var popupdata = $('#applepay-termsandconditions-popup');
			var popup = new Foundation.Reveal(popupdata);
			$('#applepay-termsandconditions-popup').html(response);
			popup.open();
            clearConsentModalError();
            analytics.appleCartDataLayerPush();
		},
		error: function () {
			alert('something went wrong');
		}
	});	
}

function clearConsentModalError() {
	var isTimer = null; 
	var $consentError = $(".paypal-express-termsandconditions-popup .paypal-express-popup-termsandconditions-error");
	var $termsandconditions = $(".paypal-express-termsandconditions-popup .user-consent-container .input-checkbox.termsandconditions");
	if(isTimer) {
		clearTimeout(isTimer);
	}
	isTimer = setTimeout(function(){
		if($consentError.is(":visible")) {		
			$termsandconditions.prop('checked', false);
			$termsandconditions.removeClass("error");
			$consentError.hide();
		}
	}, 0)	
}

// Enable or disable coupon form button based on coupon code
function enableDisableButtonBasedOnCoupon() {
    if($('input[name$="couponCode"]').val() == "") {
        $('#add-coupon').prop('disabled', true);
    } else {
        $('#add-coupon').prop('disabled', false);
    }
}

$('input[name$="_cart_couponCode"]').on('keyup',function() {
    enableDisableButtonBasedOnCoupon();
    hideCouponError();
});

//Enable Coupon Apply button on paste,cut 
$('input[name$="_cart_couponCode"]').on('paste cut',function() {
    setTimeout(() => {
        enableDisableButtonBasedOnCoupon();
    }, 500);
});

function promoCodeBehaviour() {
    var removeItemEvent = false;
    $('button[name$="deleteProduct"], button[name$="addCoupon"], button[name$="deleteCoupon"],button[name$="addBonusProduct"]').unbind();
    $('button[name$="deleteProduct"], button[name$="addCoupon"], button[name$="deleteCoupon"],button[name$="addBonusProduct"]').on('click',function (e) {
        if (removeItemEvent) {
            e.preventDefault();
            return;
        }
        removeItemEvent = true;
        e.preventDefault();
        var $form = $('form#cart-items-form');
        var action = $form &&  $form[0] ? $form[0].action : '';
        var $removeButton = $(this);
        var postData;
        if($removeButton.attr('name') == 'dwfrm_cart_addBonusProduct') {
            action = Urls.addBonusProductsAJAX;
            postData = {
                'pid': $removeButton.attr('data-pid'),
                'bliUUID': $removeButton.attr('data-bliUUID'),
                'format': 'ajax'
            }
        } else {
            postData = $form.serialize() + '&' + $removeButton.attr('name') +'='+($removeButton.val() || $removeButton.attr('name'))+'&format=ajax';
        }
        if($(this).hasClass('btn-remove-cart-item')){
            let productLineItems = basketConfirmation.productLineItems;
            if (productLineItems) {
                for(let index = 0; index < productLineItems.length; index++) {
                    let productVariantsID = $(this).attr('data-pid');
                    let productVariantPID = productLineItems[index].productVariantID;
                    if(productVariantPID === productVariantsID){
                        let indices = index+1 ;
                        analytics.removeProductFromCart(indices, basketConfirmation.productLineItems[indices-1].quantity);
                    }   
                }
            }
        }
        postCartData(action, postData);
        return false;
    });
}


function hideCouponError() {
    //Hide coupon error message on change of input
    $(document).on('keyup change', '.order-totals-table .cart-coupon-code input', function (e) {
        var error_msg = $('.cart-coupon-code').find('.error');
        if (error_msg.length) {
            $(error_msg).hide();
        }
    });
}

// change quantity of product
function changeItemQuantity() {
    $('.quantity-container select').on('selectmenuchange change', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var $form = $('form#cart-items-form');
        var action = $form[0].action;
        var $removeButton = $(this);
        var postData = $form.serialize() + '&' + $removeButton.attr('name') +'='+($removeButton.val() || $removeButton.attr('name'))+'&format=ajax';
        postCartData(action, postData);
    });
}

//ajax call for cart redesign page
function postCartData(action, postData, container, callback) {
    var couponCodeText = $('input[name$="_cart_couponCode"]').val();
    let checkIfCrossSellLoaded;
     if ($('.overlay').length == 0) {
        $('body').append('<div class="overlay"></div>')
        $('.overlay').css('display', 'block');
    }
    var promoMsgState = "";
    if($(".cart-promo-icon .icon").hasClass("icon-minus")) {
        promoMsgState = "true";
    } else {
        promoMsgState = "false";
    }
    $.ajax({
        type: 'POST',
        url: action,
        data: postData,
        success: function (response) {
            if($(".cart-mini-crosssell-slot").is(":visible")) {
                checkIfCrossSellLoaded = "true";
            }
            $('#primary').html(response);
            if ($('.double-promotion-active').length) {
                $('.minicart-promotion').addClass('multiple-promotion-active');
            }
            initializeAll();
            if(!checkIfCrossSellLoaded) {
                $(".cart-mini-crosssell-slot").hide();
            }
            if ($('.cart-empty').length){
                $(window).scrollTop(0);
            } else {
                $(window).scroll();
            }
            if (promoMsgState == "false") {
                $(".cart-promo-description").addClass("hide");
                $(".cart-promo-icon .icon").removeClass("icon-minus").addClass("icon-plus");
            } else {
                $(".cart-promo-description").removeClass("hide");
                $(".cart-promo-icon .icon").addClass("icon-minus").removeClass("icon-plus");
            }
            if(couponCodeText && couponCodeText !== ""){
                analytics.couponCodeEvent(couponCodeText);
            }
            if(action == Urls.addBonusProductsAJAX) {
                analytics.addBonusProductDataLayer('pid' in postData ? postData.pid : false);
            }
            $.ajax({
                type: 'GET',
                url: Urls.showMinicart,
                success: function (minCartData) {
                    $('.header-container .minicart-link').html(minCartData);
                    updateMiniCartCount();
                    $('.overlay').remove();
                    if($(".cart-coupon-code .error").length) {
						$("#add-coupon").prop("disabled", false);
					}
                },
                error: function () {
                    page.refresh();
                }
            });
        },
        error: function () {
            page.refresh();
        }
    });
}

function initPromoMessage() {
    $(document).on("click", ".cart-promo-icon", function(e) {
        e.stopImmediatePropagation();
        $(".cart-promo-description").toggleClass("hide");
        if($(this).children().hasClass("icon-minus")) {
            $(".cart-promo-icon .icon").removeClass("icon-minus").addClass("icon-plus");
        } else {
            $(".cart-promo-icon .icon").removeClass("icon-plus").addClass("icon-minus");
        }
    });
}

//Handle Behaviour of expand and collapse of sample container
function toggleSamples() {
    $(document).on('click', '.sample-container', function(e){
        e.stopImmediatePropagation();
        if ($(this).find('.sample-header-selected').length > 0) {
            $('.sample-tiles-container').slideToggle();
            $('.chevrondown-round-icon').toggle();
            $('.chevronup-round-icon').toggle();
            $('.sample-container').toggleClass('active');
        }
    });
}


//Add selected samples in popup
function addSelectedSamplesCart() {
    $(document).on('click', 'button#samples-add-to-cart_page', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var $sampleForm = $('form.pdpForm.bundle');
        var action = $sampleForm[0].action;
        var isBonus = $(this).hasClass('bonus-add-to-cart_page');
        var cartPage = $('.cart_page').length > 0 ? true : false ;
        if ($('.overlay').length == 0) {
            $('body').append('<div class="overlay"></div>')
            $('.overlay').css('display', 'block');
        }
        if(!cartPage) {
            var postSampleData = $sampleForm.serialize() + '&format=ajax&minicart=minicart';
        } else {
            var postSampleData = $sampleForm.serialize() + '&format=ajax';
        }

        var pids = $(this).parents('form').find('input#pids').val();
        $.ajax({
            type: 'POST',
            url: action,
            data: postSampleData,
            success: function (response) {
                if(cartPage) {
                    if(isBonus) {
                        $('#cart-items-form').html(response);
                        analytics.addBonusProductDataLayer(pids);
                    } else {
                        $('.sample-container').html(response);
                    }
                } else {
                    if(isBonus) {
                        $('.mini-cart-products .ajax-loader').show();
                        $('.mini-cart-content').parent('.minicart-wrapper').html(response);
                        $('#mini-cart-mobile').html(response);
                        $('.sb-container').scrollBox();
                        minicart.init();
                        analytics.addBonusProductMinicartDataLayer(pids);
                        $('.minicart-link .mini-cart-content').addClass('qtyopenedupdate');
                        $('#mini-cart-mobile .mini-cart-content').addClass('qtyopenedupdate');
                        $('select.minicart-quantity-dropdown').selectmenu();
                        util.paraEndWithThreeDots($('.mini-cart-details .mini-cart-name strong'), 50, 38);
                        if($('.cart-body').length) {
                            $('.minicart-wrapper .mini-cart-content').hide();
                            window.location.reload();
                        }
                    } else {
                        page.refresh();
                    }

                }
                initializeAll();
                updateMiniCartCount();
                minicart.updateQuantityOnChange();
                $('.overlay').remove();
            },
            error: function () {
                page.refresh();
            }
        });
    });
}


//To select and deselect samples in sample popup
function multiSelectSample () {
    $(document).on('click', '.sample-product-tile-wrapper, .product-tile-wrapper-container', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var $this = $(this);
        var $multiSelectForm = $this.parents('form');
        var $thresholdInput = $multiSelectForm.find('input#pids');

        var selectedCount = $multiSelectForm.find('button[value="selected"]').length;
        var limitCount = $(this).closest('.sample-selection').length ? SitePreferences.SAMPLES_PER_ORDER_COUNT : window.Constants.MAX_BONUS_ITEMS;
            
        if ($('#sampleserror')) {
            $('#sampleserror').html(null);
        }

        // do checking to compare if limit is met
        var btnIsSelected = $this.find('button.multiselect').val() == 'selected';

        if (btnIsSelected || selectedCount < limitCount) {
            // toggle val/text
            var selectButton  = $(this).find('button.multiselect');
            selectButton.toggleClass('outline');
            selectButton.val(btnIsSelected ? 'selectable' : 'selected');
            $this.find('.plus-round-icon').attr('src',(btnIsSelected ? selectButton.data('select') : selectButton.data('selected')));
            if(btnIsSelected) {
                $this.removeClass('product-tile-selected');
            } else {
                $this.addClass('product-tile-selected');
            }
        } else if ($('#sampleserror')) { // cap reached, report error
            $('#sampleserror').html($("input#pids").data('error'));
        }

        var selectedProductList = [];
        var enableAddToBag = false;

        // fetch all items that are selected
        $multiSelectForm.find('button[value="selected"]').each(function(index, item) {
            selectedProductList.push($(item).data('pid'));
            enableAddToBag = true;
            //$this.addClass('product-tile-selected');
        });

        // store all selected products to hidden input
        $thresholdInput.val(selectedProductList);

        // update selected counter
        var selectedCount = parseInt(selectedProductList.length);
        var selectedLimit = parseInt(limitCount);
        $("span#sample-count").html(''+(selectedCount <= selectedLimit ? selectedCount : selectedLimit) + '/' + $('span#sample-count').data('samplesperorder'));

        // enable "Add to Bag" button
        var cartButton = $thresholdInput.data('button');
        if (enableAddToBag) {
            $('button#' + cartButton).removeAttr('disabled');
        } else {
            $('button#' + cartButton).attr('disabled', 'true');
        }
    });
}

function updateMiniCartCount() {
    const $cartCount = $('.cart-item-count').text() || 0;
    $('.minicart-quantity').text($cartCount);
}


// function to add product to cart from cross sell
function addProductFromRecomendation(pid, qty, cartAction, prodContainer, e) {
    if ($('.overlay').length == 0) {
        $('body').append('<div class="overlay"></div>')
        $('.overlay').css('display', 'block');
    }
    const $data = {
        "format": "ajax",
        "pid": pid,
        "isCartMiniCrosssell": true
    }
    $.post(Urls.addProduct, $data, function (data) {
        if (data.error) {
            $(".overlay").remove();
            // display error
            const $errEle = $(".cart-mini-recommendations .slick-active #a2c-error");
            $(".cart-mini-recommendations .slick-active #a2c-error").html(data.error).slideDown('fast', function () {
                setTimeout(function () {
                    $errEle.slideUp(500, function () {
                        // hide error after timeout
                        $(this).removeClass('active');
                    });
                }, 2000);
            });
        } else {
            const $existing = $('.cart-mini-recommendations.slick-initialized');
            if ($existing.length) {
                $existing.slick('unslick');
            }
            $(".overlay").remove();
            $('#primary').html(data);
            util.paraEndWithThreeDots($('.mini-cart-product .mini-cart-name a'), 31, 26);
            initializeAll();
            cartPageMiniRecommendations();
            updateMiniCartCount();
            changeItemQuantity();
            analytics.cartCrossSellAddToCart(prodContainer, e)
        }
    }).fail(function (err) {
        reject(err.error);
    });
}

// handles swatches from cart cross sell
$(document).on('click', '.cart-mini-crosssell-slot .custom-dd .custom-dd-list-item', function () {
	// Handles the selection of a product tile in the minicart cross sell slot. 
	const $this = $(this);
	const pid = $(this).find('.color-swatch, .swatchanchor').data('pid');
	const targetContainer = $this.parents('.cart-mini-recommendations-tile');

	const params = {
		format: 'ajax',
		pid: pid,
		templaterender: 'product/cartminicrosssell',
		showswatches: true,
		showpricing: true,
		showpromotion: true,
		isclickable: true,
		showrating: true,
		disablebvseo: true,
		showbrandname: true,
		issliderimage: false,
		source: "cartMiniCrosssell",
		isminicartcrosssell: true
	};

	ajax.load({
		url: util.appendParamsToUrl(Urls.transactionalHitTile, params),
		target: targetContainer,
		callback: function () {
			customDropdown.init();
		},
	});
}).on('click', '.cart-mini-recommendations-tile .add-to-cart', function(e) {
    // add product from mini cross sell from cart
    e.preventDefault();
    const $this = $(this);
    const pid = $this.data('pid');
    const qty = $this.data('quantity');
    const cartAction = $(this).data('cartaction');
    const prodContainer = $this.closest('.cart-mini-recommendations-tile');
    addProductFromRecomendation(pid, qty, cartAction, prodContainer, e);
});

/**
 * Initializes the minicart recommendations carousel and related UI once the container is available.
 *
 * - Waits for `cart-mini-recommendation-container .cart-mini-recommendations`.
 * - Applies Slick with configured options and responsive behavior; skips if already initialized.
 * - Initializes custom dropdowns and updates minicart layout/cart icon behavior.
 */
const cartPageMiniRecommendations = function () {
    return new Promise(function (resolve, reject) {
        const maxAttempts = 10;
        const retryDelay = 500;
        let attempts = 0;

        function checkAndInitialize($recommendations) {
            attempts++;
            // Check if slot content has been rendered
            const hasContent = $recommendations.children().length > 0;
            if (!hasContent && attempts < maxAttempts) {
                setTimeout(function () {
                    checkAndInitialize($recommendations);
                }, retryDelay);

                return;
            }

            // Hide loader once we have content or exhausted all attempts
            $(".tile-ajax-loader").hide();

            // If all attempts are exhausted and there is still no content,
            // hide the entire cross-sell section
            if (!hasContent && attempts >= maxAttempts) {
                $(".cart-mini-recommendation-container").hide();
                resolve($recommendations);
                return;
            }

            // If Slick is already initialized
            if ($recommendations.hasClass('slick-initialized')) {
                customDropdown.init();
                resolve($recommendations);
                return;
            }

            // Initialize Slick
            $recommendations.slick({
                initialSlide: 0,
                autoplay: false,
                dots: false,
                arrows: true,
                swipe: true,
                infinite: false,
                speed: 150,
                slidesToShow: 1,
                swipeToSlide: 1,
                fade: false,
                cssEase: 'linear',
                variableWidth: true,
                nextArrow: '<div class="slick-next"><i class="icon icon-rightCarrot"></i></div>',
                prevArrow: '<div class="slick-prev"><i class="icon icon-leftCarrot"></i></div>'
            });

            // Slick init event
            let resolved = false;

            $recommendations.one('init', function () {
                if (!resolved) {
                    resolved = true;
                    customDropdown.init();
                    resolve($recommendations);
                    analytics.cartCrossSellafterInit($recommendations);
                }
            });

            // Fallback in case init event doesn't fire
            setTimeout(function () {
                if (!resolved) {
                    resolved = true;
                    customDropdown.init();
                    resolve($recommendations);
                    analytics.cartCrossSellafterInit($recommendations);
                }
            }, 100);
        }

        util.waitForElement('.cart-mini-recommendation-container .cart-mini-recommendations')
            .then(function ($recommendations) {
                checkAndInitialize($recommendations);
            })
            .catch(function (err) {
                console.warn('Error in cartRecommendations:', err);
                reject(err);
            });
    });
};

function initializeAll() {
    cartPageMiniRecommendations();
    login.init();
    initializeEvents();
    recommendations.init();
    isGift();
    giftMessage();
    cartCount();
    giftShipping.init();
    if (SitePreferences.STORE_PICKUP) {
        cartStoreInventory.init();
    }
    account.initCartLogin();
    checkoutReinsurancePopup();
    cartPayPalExpressPopup();
	// below functions are used for cart redesign
    if($('.pt_cart').length >= 1) {
	    promoCodeBehaviour();
        if ($('.double-promotion-active').length) {
                $('.minicart-promotion').addClass('multiple-promotion-active');
            }
    }
    hideCouponError();
    addSelectedSamplesCart();
    multiSelectSample();
    toggleSamples();
    changeItemQuantity();
	setTimeout(function() {
		tooltip.init();
	}, 500);
    initPromoMessage();
    reinsuranceCart();
}

export default {
    init: initializeAll,
    postAppleErr: postAppleErr,
    getApplePayDisplayNationality: getApplePayDisplayNationality,
    getPayPalExpressConsentModal: getPayPalExpressConsentModal,
    addSelectedSamplesCart: addSelectedSamplesCart,
    multiSelectSample: multiSelectSample,
    cartPayPalExpressPopup: cartPayPalExpressPopup
};